import { render } from "./AutoComplete.vue?vue&type=template&id=397481a5"
import script from "./AutoComplete.vue?vue&type=script&lang=js"
export * from "./AutoComplete.vue?vue&type=script&lang=js"

import "./AutoComplete.vue?vue&type=style&index=0&id=397481a5&lang=css"
script.render = render

export default script